type ConnectableRule = {
  variants: Array<{ treatments?: Array<{ type: string; channelMarkupId?: string }> }>;
};

/**
 * svc-promo returns every rule of a router that references the markup, so a
 * router holding several rules can bring along rules that never apply it.
 */
export function getRulesApplyingChannelMarkup<T extends ConnectableRule>(
  rules: Array<T>,
  channelMarkupId: string,
): Array<T> {
  return rules.filter((rule) =>
    rule.variants.some((variant) =>
      (variant.treatments ?? []).some(
        (treatment) => treatment.type === 'channel-markup' && treatment.channelMarkupId === channelMarkupId,
      ),
    ),
  );
}
